// FIXME:F2TS type import from flow
import { SanitizeFunctionType } from 'helper/sanitizer';
import maxLength from 'helper/sanitizer/max-length';

export default (beforeMaxLength: number, afterMaxLength: number): SanitizeFunctionType => {
	return (value: string): string => {
		if (typeof value !== 'string') {
			return '';
		}
		const valueSpl: Array<string> = value.split('.');
		if (valueSpl.length > 1) {
			return `${maxLength(beforeMaxLength)(valueSpl[0])}.${maxLength(afterMaxLength)(valueSpl[1])}`;
		}
		return maxLength(beforeMaxLength)(valueSpl[0]);
	};
};
